import { isThemeSupported, ThemeAlias } from '@neptune/shared/venus-domain';

export type DbPersistedThemeConfig = {
  selectedTheme: ThemeAlias;
};

export const DB_PERSISTED_THEME_CONFIG_KEY: keyof DbPersistedThemeConfig = 'selectedTheme';

export function isThemeAlias(value: any): value is ThemeAlias {
  return typeof value === 'string' && isThemeSupported(value);
}
